import React, { useState, useEffect } from 'react';
import { Download, X, Calendar } from 'lucide-react';
import AdminSettings from './AdminSettings';
import PayrollDashboard from './PayrollDashboard';
import BookingDetails from './BookingDetails';
import AdminCustomers from './AdminCustomers';
import { supabase } from '../services/supabaseClient';


const ProfitCalculator = () => {
const [calc, setCalc] = useState({
service: 'deep', sqm: '80', workers: '2', hours: '4.5', hourlyWage: '180'
});

const rates = { standard: 65, deep: 80, moving: 95, office: 75, help: 450, window: 195 };
const minPrices = { standard: 3490, deep: 5490, moving: 7490, office: 4490, help: 2250 };
const ARBETSGIVARAVGIFT = 0.3142;
const noRut = ['office'];
const RUT = noRut.includes(calc.service) ? 0 : 0.50;

const sqm = parseInt(calc.sqm) || 0;
const workers = parseInt(calc.workers) || 1;
const hours = parseFloat(calc.hours) || 0;
const hourlyWage = parseInt(calc.hourlyWage) || 180;


const calculated = sqm * (rates[calc.service] || 72);
const grossRevenue = Math.max(calculated, minPrices[calc.service] || 3990);
const rutDiscount = grossRevenue * RUT;
const customerPays = grossRevenue - rutDiscount;
const wagePerWorker = hours * hourlyWage;
const totalWages = workers * wagePerWorker;
const socialFees = totalWages * ARBETSGIVARAVGIFT;
const totalLaborCost = totalWages + socialFees;
const profit = grossRevenue - totalLaborCost;
const profitMargin = grossRevenue > 0 ? (profit / grossRevenue * 100).toFixed(1) : 0;

const cardStyle = { backgroundColor: '#fff', border: '1px solid #e8e4d9', borderRadius: '16px', padding: '24px', marginBottom: '16px' };
const inputStyle = { width: '100%', padding: '10px 14px', borderRadius: '10px', border: '2px solid #e8e4d9', backgroundColor: '#f8f7f4', color: '#1a1a2e', outline: 'none' };

return (
<div className="max-w-2xl">
<h2 className="text-2xl font-bold mb-2" style={{ color: '#1a1a2e' }}>💰 Vinstmarginal Kalkylator</h2>
<p className="mb-6 text-sm" style={{ color: '#888' }}>Beräkna vinst per jobb baserat på lön och arbetstid</p>

<div style={cardStyle}>
<h3 className="font-bold mb-4" style={{ color: '#1a1a2e' }}>Jobbdetaljer</h3>
<div className="grid grid-cols-2 gap-4">
<div>
<label className="block text-sm font-bold mb-1" style={{ color: '#1a1a2e' }}>Tjänst</label>
<select value={calc.service} onChange={(e) => setCalc(p => ({ ...p, service: e.target.value }))} style={inputStyle}>
<option value="standard">Standardstädning (65 kr/m²)</option>
<option value="deep">Djupstädning (80 kr/m²)</option>
<option value="moving">Flyttstädning (95 kr/m²)</option>
<option value="office">Kontorsstädning (75 kr/m²) — Ingen RUT</option>
<option value="help">Flytthjälp (450 kr/h/person)</option>
<option value="window">Fönsterputs</option>
</select>
</div>
<div>
<label className="block text-sm font-bold mb-1" style={{ color: '#1a1a2e' }}>Kvadratmeter</label>
<input type="number" value={calc.sqm} onChange={(e) => setCalc(p => ({ ...p, sqm: e.target.value }))} style={inputStyle}/>
</div>
<div>
<label className="block text-sm font-bold mb-1" style={{ color: '#1a1a2e' }}>Antal personal</label>
<input type="number" value={calc.workers} onChange={(e) => setCalc(p => ({ ...p, workers: e.target.value }))} style={inputStyle}/>
</div>
<div>
<label className="block text-sm font-bold mb-1" style={{ color: '#1a1a2e' }}>Arbetstimmar per person</label>
<input type="number" step="0.5" value={calc.hours} onChange={(e) => setCalc(p => ({ ...p, hours: e.target.value }))} style={inputStyle}/>
</div>
<div className="col-span-2">
<label className="block text-sm font-bold mb-1" style={{ color: '#1a1a2e' }}>Timlön (kr/h)</label>
<input type="number" value={calc.hourlyWage} onChange={(e) => setCalc(p => ({ ...p, hourlyWage: e.target.value }))} style={inputStyle}/>
</div>
</div>
</div>

<div style={cardStyle}>
<h3 className="font-bold mb-4" style={{ color: '#1a1a2e' }}>Beräkning</h3>
<div className="space-y-3">
<div className="flex justify-between py-2" style={{ borderBottom: '1px solid #e8e4d9' }}>
<span style={{ color: '#555' }}>Totalt pris ({sqm} m² × {rates[calc.service]} kr)</span>
<span className="font-bold" style={{ color: '#1a1a2e' }}>{grossRevenue.toLocaleString()} kr</span>
</div>
<div className="flex justify-between py-2" style={{ borderBottom: '1px solid #e8e4d9' }}>
<span style={{ color: '#555' }}>Kunden betalar (50% efter RUT)</span>
<span className="font-bold" style={{ color: '#1a1a2e' }}>{Math.round(customerPays).toLocaleString()} kr</span>
</div>
<div className="flex justify-between py-2" style={{ borderBottom: '1px solid #e8e4d9' }}>
<span style={{ color: '#555' }}>Skatteverket betalar (50% RUT)</span>
<span className="font-bold" style={{ color: '#16a34a' }}>{Math.round(rutDiscount).toLocaleString()} kr</span>
</div>
<div className="flex justify-between py-2" style={{ borderBottom: '1px solid #e8e4d9' }}>
<span style={{ color: '#555' }}>Du får totalt</span>
<span className="font-bold text-lg" style={{ color: '#1a1a2e' }}>{grossRevenue.toLocaleString()} kr</span>
</div>
<div className="flex justify-between py-2" style={{ borderBottom: '1px solid #e8e4d9' }}>
<span style={{ color: '#555' }}>Löner ({workers} × {hours}h × {hourlyWage} kr)</span>
<span className="font-bold" style={{ color: '#dc2626' }}>-{Math.round(totalWages).toLocaleString()} kr</span>
</div>
<div className="flex justify-between py-2" style={{ borderBottom: '1px solid #e8e4d9' }}>
<span style={{ color: '#555' }}>Arbetsgivaravgift (31.42%)</span>
<span className="font-bold" style={{ color: '#dc2626' }}>-{Math.round(socialFees).toLocaleString()} kr</span>
</div>
<div className="flex justify-between py-3 rounded-xl px-4 mt-2"
style={{ backgroundColor: profit >= 0 ? '#dcfce7' : '#fee2e2' }}>
<span className="font-bold text-lg" style={{ color: profit >= 0 ? '#16a34a' : '#dc2626' }}>Din vinst</span>
<span className="font-bold text-2xl" style={{ color: profit >= 0 ? '#16a34a' : '#dc2626' }}>
{Math.round(profit).toLocaleString()} kr
</span>
</div>
<div className="text-center py-2">
<span className="text-sm" style={{ color: '#888' }}>Vinstmarginal: </span>
<span className="font-bold" style={{ color: profit >= 0 ? '#16a34a' : '#dc2626' }}>{profitMargin}%</span>
</div>
</div>
</div>

<div style={{ ...cardStyle, backgroundColor: '#1a1a2e' }}>
<h3 className="font-bold mb-3" style={{ color: '#C9A84C' }}>💡 Tips</h3>
<ul className="text-sm space-y-2" style={{ color: 'rgba(255,255,255,0.7)' }}>
<li>• Du förlorar INGET på RUT — du får alltid hela priset (50% från kund + 50% från staten)</li>
<li>• Sträva efter 45-55% vinstmarginal per jobb</li>
<li>• Arbetsgivaravgiften är 31.42% ovanpå lönen — glöm inte det!</li>
<li>• Minpriserna skyddar dig på små jobb</li>
</ul>
</div>
</div>
);
};

const AdminDashboard = ({ onLogout }) => {
const [bookings, setBookings] = useState([]);
const [loading, setLoading] = useState(true);
const [adminFilter, setAdminFilter] = useState('all');
const [activeTab, setActiveTabRaw] = useState('bookings');
const [resetKey, setResetKey] = useState(0);
const [openCustomerEmail, setOpenCustomerEmail] = useState(null);
const [customerEmails, setCustomerEmails] = useState([]);
const setActiveTab = (tab) => {
  setActiveTabRaw(tab);
  setResetKey(k => k + 1);
  setOpenCustomerEmail(null);
  if (tab === 'bookings') { setAdminFilter('all'); loadBookings(); }
};


useEffect(() => {
  loadBookings();
  supabase.from('users').select('email').eq('role', 'customer')
    .then(({ data }) => setCustomerEmails((data || []).map(u => (u.email || '').toLowerCase())));
}, []);


const loadBookings = async () => {
  try {
    setLoading(true);
    const { data, error } = await supabase.from('bookings').select('*').order('date', { ascending: false }).order('time', { ascending: false })
    if (error) throw error;
    setBookings((data || []).map(b => ({ ...b, finalPrice: b.final_price, postalCode: b.postal_code, createdAt: b.created_at })));
  } catch (error) {
    console.error('Error loading bookings:', error);
  } finally {
    setLoading(false);
  }
};

const toggleBookingStatus = async (bookingId, currentStatus) => {
  await supabase.from('bookings').update({ status: currentStatus === 'upcoming' ? 'completed' : 'upcoming' }).eq('id', bookingId);
  await loadBookings();
};

const deleteBooking = async (bookingId) => {
  if (window.confirm('Är du säker på att du vill ta bort denna bokning?')) {
    await supabase.from('bookings').delete().eq('id', bookingId);
    await loadBookings();
  }
};

const updateMaxWorkers = async (bookingId, num) => {
  await supabase.from('bookings').update({ max_workers: num }).eq('id', bookingId);
  await loadBookings();
};


const sendWorkerReminder = async (booking) => {
try {
const response = await fetch('/.netlify/functions/send-worker-reminder', {
method: 'POST',
headers: { 'Content-Type': 'application/json' },
body: JSON.stringify({
bookingId: booking.id,
maxWorkers: booking.max_workers || 2,
date: booking.date,
time: booking.time,
service: booking.service,
city: booking.city,
sqm: booking.sqm
})
});
const result = await response.json().catch(() => ({}));
if (response.ok) alert(result.message || '✅ Påminnelse skickad!');
else alert('❌ Misslyckades: ' + (result.error || 'okänt fel'));
} catch (error) {
alert('❌ Kunde inte skicka påminnelse');
}
};

const exportBookings = () => {
const csv = [
['Datum', 'Tid', 'Namn', 'Email', 'Telefon', 'Adress', 'Tjänst', 'Kvm', 'Pris (efter RUT)', 'Status'].join(','),
...bookings.map(b => [b.date, b.time, b.name, b.email, b.phone,
`${b.address} ${b.city}`, serviceNames[b.service] || b.service,
b.sqm, `${b.finalPrice} kr`,
b.status === 'upcoming' ? 'Kommande' : 'Slutförd'].join(','))
].join('\n');
const blob = new Blob([csv], { type: 'text/csv' });
const url = window.URL.createObjectURL(blob);
const a = document.createElement('a');
a.href = url;
a.download = `galax-bookings-${new Date().toISOString().split('T')[0]}.csv`;
a.click();
};

const filteredBookings = bookings.filter(b => adminFilter === 'all' ? true : adminFilter === 'manual' ? !!b.details?.manual : b.status === adminFilter);
const totalRevenue = bookings.filter(b => b.status === 'completed').reduce((sum, b) => sum + (b.price || 0), 0)

const serviceNames = {
standard: 'Standardstädning', deep: 'Djupstädning',
moving: 'Flyttstädning', office: 'Kontorsstädning', help: 'Flytthjälp'
};

const cardStyle = { backgroundColor: '#fff', border: '1px solid #e8e4d9', borderRadius: '12px', padding: '24px' };

return (
<div className="max-w-6xl mx-auto" style={{ color: '#1a1a2e' }}>
<div className="flex flex-wrap gap-3 mb-8">
<button onClick={() => { setActiveTab('bookings'); loadBookings(); }}
className="px-6 py-3 rounded-full font-bold transition-all"
style={{ backgroundColor: activeTab === 'bookings' ? '#1a1a2e' : '#f8f7f4', color: activeTab === 'bookings' ? '#C9A84C' : '#555', border: '2px solid #e8e4d9' }}>
Bokningar ({bookings.length})
</button>
<button onClick={() => setActiveTab('calculator')}
className="px-6 py-3 rounded-full font-bold transition-all"
style={{ backgroundColor: activeTab === 'calculator' ? '#1a1a2e' : '#f8f7f4', color: activeTab === 'calculator' ? '#C9A84C' : '#555', border: '2px solid #e8e4d9' }}>
💰 Kalkylator
</button>
<button onClick={() => setActiveTab('settings')}
className="px-6 py-3 rounded-full font-bold transition-all"
style={{ backgroundColor: activeTab === 'settings' ? '#1a1a2e' : '#f8f7f4', color: activeTab === 'settings' ? '#C9A84C' : '#555', border: '2px solid #e8e4d9' }}>
Inställningar
</button>
<button onClick={() => setActiveTab('customers')}
className="px-6 py-3 rounded-full font-bold transition-all"
style={{ backgroundColor: activeTab === 'customers' ? '#1a1a2e' : '#f8f7f4', color: activeTab === 'customers' ? '#C9A84C' : '#555', border: '2px solid #e8e4d9' }}>
👥 Kunder
</button>
<button onClick={() => setActiveTab('payroll')}
className="px-6 py-3 rounded-full font-bold transition-all"
style={{ backgroundColor: activeTab === 'payroll' ? '#1a1a2e' : '#f8f7f4', color: activeTab === 'payroll' ? '#C9A84C' : '#555', border: '2px solid #e8e4d9' }}>
💰 Löner
</button>
</div>

{activeTab === 'bookings' && (
<>
<div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
{[
{ label: 'Totala Bokningar', value: bookings.length, color: '#1a1a2e' },
{ label: 'Kommande', value: bookings.filter(b => b.status === 'upcoming').length, color: '#3b82f6' },
{ label: 'Slutförda', value: bookings.filter(b => b.status === 'completed').length, color: '#16a34a' },
{ label: 'Total Intäkt (hela beloppet)', value: `${Math.round(totalRevenue).toLocaleString()} kr`, color: '#C9A84C' }
].map((stat, idx) => (
<div key={idx} style={cardStyle}>
<p className="text-sm mb-1" style={{ color: '#888' }}>{stat.label}</p>
<p className="text-3xl font-bold" style={{ color: stat.color }}>{stat.value}</p>
</div>
))}
</div>

<div className="flex flex-wrap justify-between items-center mb-6 gap-4">
<div className="flex flex-wrap gap-2">
{[
{ key: 'all', label: `Alla (${bookings.length})` },
{ key: 'manual', label: `Manuella Bokningar (${bookings.filter(b => b.details?.manual).length})` },
{ key: 'upcoming', label: `Kommande (${bookings.filter(b => b.status === 'upcoming').length})` },
{ key: 'completed', label: `Slutförda (${bookings.filter(b => b.status === 'completed').length})` }
].map(({ key, label }) => (
<button key={key} onClick={() => setAdminFilter(key)}
className="px-4 py-2 rounded-full font-semibold transition-all text-sm"
style={{ backgroundColor: adminFilter === key ? '#1a1a2e' : '#f8f7f4', color: adminFilter === key ? '#C9A84C' : '#555', border: '2px solid #e8e4d9' }}>
{label}
</button>
))}
</div>
<button onClick={exportBookings} disabled={bookings.length === 0}
className="px-4 py-2 rounded-full font-semibold transition-all flex items-center space-x-2 text-sm"
style={{ backgroundColor: '#16a34a', color: '#fff', opacity: bookings.length === 0 ? 0.5 : 1 }}>
<Download className="w-4 h-4" /><span>Exportera CSV</span>
</button>
</div>

<div className="space-y-4">
{loading ? (
<div className="text-center py-12" style={{ color: '#888' }}>Laddar bokningar...</div>
) : filteredBookings.length === 0 ? (
<div className="text-center py-12" style={{ color: '#888' }}>Inga bokningar att visa</div>
) : (
filteredBookings.map((booking) => (
<div key={booking.id} style={cardStyle}>
<div className="flex flex-wrap justify-between items-start mb-4 gap-4">
<div>
<div className="flex flex-wrap items-center gap-3 mb-2">
{customerEmails.includes((booking.email || '').toLowerCase()) ? (
  <button onClick={() => { setOpenCustomerEmail(booking.email); setActiveTabRaw('customers'); setResetKey(k => k + 1); }}
    className="text-xl font-bold underline" style={{ color: '#1a1a2e', textDecorationColor: '#C9A84C' }}>
    {booking.name}
  </button>
) : (
  <h3 className="text-xl font-bold" style={{ color: '#1a1a2e' }}>{booking.name}</h3>
)}
<span className="px-3 py-1 rounded-full text-xs font-bold"
style={{ backgroundColor: booking.status === 'upcoming' ? '#dbeafe' : '#dcfce7', color: booking.status === 'upcoming' ? '#1d4ed8' : '#16a34a' }}>
{booking.status === 'upcoming' ? 'KOMMANDE' : 'SLUTFÖRD'}
</span>
  </div>
  <p className="text-sm" style={{ color: '#888' }}>{serviceNames[booking.service] || booking.service}</p>
  </div>
<div className="text-right">
  <p className="text-2xl font-bold" style={{ color: '#C9A84C' }}>{Math.round(booking.price || 0).toLocaleString()} kr</p>
  <p className="text-xs" style={{ color: '#aaa' }}>totalt (hela beloppet)</p>
  {booking.rut_discount > 0 && (
    <p className="text-xs mt-1" style={{ color: '#555' }}>Kunden betalar {Math.round(booking.finalPrice || 0).toLocaleString()} kr • Skatteverket {Math.round(booking.rut_discount).toLocaleString()} kr</p>
  )}
</div>
  </div>

<div className="grid md:grid-cols-2 gap-4 text-sm mb-4">
<div>
<p className="font-semibold mb-1" style={{ color: '#888' }}>Kontakt:</p>
<p style={{ color: '#1a1a2e' }}>{booking.email}</p>
<p style={{ color: '#1a1a2e' }}>{booking.phone}</p>
</div>
<div>
<p className="font-semibold mb-1" style={{ color: '#888' }}>Datum & Tid:</p>
<p className="flex items-center" style={{ color: '#1a1a2e' }}>
<Calendar className="w-4 h-4 mr-2" style={{ color: '#C9A84C' }} />
{booking.date} kl {booking.time}
</p>
</div>
<div>
<p className="font-semibold mb-1" style={{ color: '#888' }}>Adress:</p>
<p style={{ color: '#1a1a2e' }}>{booking.address}</p>
<p style={{ color: '#1a1a2e' }}>{booking.city} {booking.postalCode}</p>
</div>
<div>
<p className="font-semibold mb-1" style={{ color: '#888' }}>Detaljer:</p>
<p style={{ color: '#1a1a2e' }}>{booking.sqm} kvm</p>
{booking.notes && <p className="text-xs mt-1" style={{ color: '#888' }}>"{booking.notes}"</p>}
</div>
</div>

<BookingDetails details={booking.details} />

{/* Max workers selector */}
<div className="mb-3 p-3 rounded-xl" style={{ backgroundColor: '#f8f7f4', border: '1px solid #e8e4d9' }}>
<div className="flex items-center gap-2 mb-2 flex-wrap">
<span className="text-sm font-semibold" style={{ color: '#888' }}>Max personal:</span>
{[1, 2, 3, 4].map(num => (
<button key={num} onClick={() => updateMaxWorkers(booking.id, num)}
className="w-8 h-8 rounded-full font-bold text-sm transition-all"
style={{
backgroundColor: (booking.max_workers || 2) === num ? '#1a1a2e' : '#fff',
color: (booking.max_workers || 2) === num ? '#C9A84C' : '#555',
border: '2px solid #e8e4d9'
}}>
{num}
</button>
))}
<span className="text-xs ml-1" style={{ color: '#aaa' }}>
({booking.accepted_count || 0} accepterade)
</span>
</div>
<button onClick={() => sendWorkerReminder(booking)}
className="w-full py-2 rounded-xl font-semibold text-sm transition-all"
style={{ backgroundColor: '#1a1a2e', color: '#C9A84C', border: '1px solid #C9A84C' }}>
📢 Skicka påminnelse till anställda
</button>
</div>

<div className="flex flex-wrap gap-2">
<button onClick={() => toggleBookingStatus(booking.id, booking.status)}
className="px-4 py-2 rounded-full font-semibold transition-all text-sm"
style={{ backgroundColor: booking.status === 'upcoming' ? '#16a34a' : '#3b82f6', color: '#fff' }}>
{booking.status === 'upcoming' ? 'Markera som Slutförd' : 'Markera som Kommande'}
</button>
<button onClick={() => deleteBooking(booking.id)}
className="px-4 py-2 rounded-full font-semibold transition-all flex items-center space-x-2 text-sm"
style={{ backgroundColor: '#fee2e2', color: '#dc2626' }}>
<X className="w-4 h-4" /><span>Ta Bort</span>
</button>
</div>
</div>
))
)}
</div>
</>
)}

{activeTab === 'calculator' && <ProfitCalculator />}
{activeTab === 'settings' && <AdminSettings />}
{activeTab === 'payroll' && <PayrollDashboard key={resetKey} currentUser={{ role: 'admin' }} />}
{activeTab === 'customers' && <AdminCustomers key={resetKey} openEmail={openCustomerEmail} />}
</div>
);
};

export default AdminDashboard;